
import React, { createContext, useContext } from 'react';
import { useCart } from '@/hooks/useCart';

// Re-export the CartItem type properly with 'export type'
import type { CartItem } from '@/hooks/useCart';
export type { CartItem };

interface CartContextType {
  items: CartItem[];
  addItem: (item: CartItem) => void;
  updateItemQuantity: (id: string, quantity: number) => void;
  removeItem: (id: string) => void;
  clearCart: () => void;
  subtotal: number;
  total: number;
  itemCount: number;
  isLoading: boolean;
  // Promo code
  appliedPromoCode: string | null;
  discount: number;
  isApplyingPromo: boolean;
  promoError: string | null;
  applyPromoCode: (code: string) => Promise<boolean>;
  removePromoCode: () => void;
}

const CartContext = createContext<CartContextType | undefined>(undefined);

export const CartProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const cart = useCart();

  return (
    <CartContext.Provider value={cart}>
      {children}
    </CartContext.Provider>
  );
};

export const useCartContext = () => {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCartContext must be used within a CartProvider');
  }
  return context;
};

// Re-export the useCart hook for direct usage
export { useCart };
